import React from 'react'
import { Box, Typography, Container } from '@mui/material'
import Navbar from '../../../shared/Navbar'
import MysteryShopperForm from './MysteryShopperForm'

const MysteryShopper = () => (
  <Container component='main'>
    <Navbar />
    <Box textAlign='center' mt={12} mb={8}>
      <Typography
        sx={{
          fontSize: { xs: '30px', md: '50px' },
          fontFamily: 'Corsica LX Bold',
          lineHeight: 1,
        }}
      >
        Mystery Shopper
      </Typography>
    </Box>
    <Box m={2} mb={8}>
      <MysteryShopperForm></MysteryShopperForm>
    </Box>
  </Container>
)

export default MysteryShopper
